import axios from "axios"

//pass new generated access token here
const token = localStorage.getItem('token')

//apply base url for axios
// const API_URL = "http://localhost:4009/api/v1"
const API_URL = "https://canteen.ademanagement.in/api/v1"

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
})

axiosApi.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(token)}`

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
